import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SupportTicketService {
  private apiEndpoint = environment.apiUrl + environment.helpDeskConfig.supportTicketEndpoint;

  constructor(private http: HttpClient) {}

  createSupportTicket(
    title: string,
    description: string,
    files: File[],
  ): Observable<any> {
    const formData = new FormData();
    formData.append('Title', title);
    formData.append('Description', description);
    if (files) {
      files.forEach((file) => {
        formData.append('Attachments', file);
      });
    }
    return this.http.post<any>(this.apiEndpoint, formData);
  }
}
